// extracted by mini-css-extract-plugin
module.exports = {"cookiePreferencesButton":"_33AQOXuaGWCMNImnN31X4J","privacyPolicyText":"NtbLB2UIaaXstETmf7fWR"};